module.exports = __webpack_public_path__ + "static/media/14UNEP12.f801eb1a.jpg";